export class Material {
	public static UNKNOWN: number = 0;
	public static WOOD: number = 1;
	public static STEEL: number = 2;
	public static ALU: number = 3;
}